import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LayoutModule } from '@angular/cdk/layout';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { StorageModule } from './storage/storage.module';
import { RestModule } from './rest/rest.module';
import { DataSourceModule } from './datatable/datasource.module';
import { TimezoneService } from './date/timezone.service';
import { DateFormatterService } from './date/date-formatter.service';
import { DateParserService } from './date/date-parser.service';
import { DateCodecService } from './date/date-codec.service';
import { ErrorHandlerService } from './error-handler.service';
import { ProvincesStatesCodesService } from './provinces-states/provinces-states-codes.service';

@NgModule({
  imports: [
    CommonModule,
    StorageModule,
    RestModule,
    DataSourceModule,
    LayoutModule,
    ScrollingModule
  ],
  providers: [
    TimezoneService,
    {
      provide: 'window',
      useValue: window
    },
    ProvincesStatesCodesService,
    DateFormatterService,
    DateCodecService,
    DateParserService,
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class ServicesModule {
}
